import config from "config/config";
import { PlaneWithClockIcon, ConsultantIcon, FoodIcon } from "styles/icons";

export const HOW_SCORE_IS_CALCULATED_AIRPORTS_ITEMS = [
  {
    icon: PlaneWithClockIcon,
    header: "on_time_performance",
    description: "airport_on_time_performance_desc",
  },
  { icon: ConsultantIcon, header: "service_quality", description: "airport_service_quality_desc" },
  { icon: FoodIcon, header: "food_and_shops", description: "airport_food_and_shops_desc" },
];

export const AIRPORTS_METHODOLOGY_PDF_LINK =
  "https://static.airhelp.com/pdf/2019-airport-score/methodology_airhelp_score_2019__global_airport_rankings-en_us.pdf";

export const AIRLINE_POST_IMAGE = `${config.staticUrl}/i/airhelp-score/airline_ranking_featured.jpeg`;
